export enum CreativeDetailsTabType {
    Preview = 0,
    IABCategories = 1,
    Details = 2
};